import { Controller } from "stimulus"

export default class extends Controller {

    calculateCPM() {
        var isFormValid = document.getElementById("campaign_cost").checkValidity() && document.getElementById("ad_impression").checkValidity()
        if (isFormValid) {
            var campaignCost = Number(document.getElementById("campaign_cost").value) || 0;
            var adImpression = Number(document.getElementById("ad_impression").value) || 0;
            var cpmRate;
            var format = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
            });
            cpmRate = campaignCost * 1000 / adImpression || 0;
            document.getElementById("campaign-cost").innerText = `${format.format(campaignCost)}`;
            document.getElementById("ad-impression").innerText = `${adImpression.toFixed('2')}`;
            document.getElementById("cpm-rate").innerText = `${format.format(cpmRate)}`;
            document.getElementById("cpm-calculation").classList.remove("hidden");
        }
    }

    reset() {
        document.getElementById("campaign_cost").value = null
        document.getElementById("ad_impression").value = null
        document.getElementById("campaign-cost").innerText = '';
        document.getElementById("ad-impression").innerText = '';
        document.getElementById("cpm-rate").innerText = '';
        document.getElementById("cpm-calculation").classList.add("hidden");
        document.getElementById("campaign_cost").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("campaign_cost").classList.remove("pt-4");
        document.getElementById("ad_impression").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("ad_impression").classList.remove("pt-4");
    }

    toggleLabel(event) {
        if (event.target.value.length == 0) {
            event.target.previousSibling.previousSibling.classList.add("opacity-0");
            event.target.classList.remove("pt-4");
        } else {
            event.target.previousSibling.previousSibling.classList.remove("opacity-0");
            event.target.classList.add("pt-4");
        }
    }
}